import React, { useState } from 'react';
import { Grid, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SelectAll from "../SelectAll/index"
import Select from "react-select";
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';

const SubHeader = (props) => {
    const [status, setStatus] = useState('')
    const jobStatus = [
        { value: 'All User', label: 'All Users' },
        { value: 'New to Old', label: 'New to Old' },
        { value: 'Old to New', label: 'Old to New' },
    ];
    function customTheme(theme) {
        return {
            ...theme,
            colors: {
                ...theme.colors,
                primary25: "#F2F2F2",
                primary: "#72727233",
            },
        };
    }

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            borderBottom: "none",

            color: "black",
            backgroundColor: "white",
            "&:hover": {
                backgroundColor: "#F0F8F9"
            }

        }),
        menu: () => ({
            width: '190px',
             boxShadow : '0px 3px 6px #00000029',
             border:'0.5px solid #E5E5E5',
             backgroundColor:'white',
        }),
        control: () => ({
            display: "flex",
            border: "1.3px solid #3c8c9e",
            backgroundColor: "none",
            borderRadius: "3px",
            padding: "4px 0px",
            minHeight: '20px',
            height: '25px',
            width: '190px'
        }),
        input: (provided) => ({
            ...provided,
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: "14px",
            color: "#000000",
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: "none",
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "rgba(0, 0, 0, 0.25)",
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            color: "#0D5C75",
        }),
        valueContainer: (provided) => ({
            ...provided,
        }),
    };


    return (
        <Grid style={{ display: "flex", justifyContent: 'space-between', position: "sticky", top: "0", width: '95%', zIndex: '1' }}>
            <ArrowBackIcon
                style={{ fontSize: "20", color: "#0d4f57", justifyContent: "left", }} />
            <Typography
                pl={2}
                style={{
                    fontSize: "15px", fontWeight: '500', letterSpacing: '1', color: '#888888', paddingLeft: '10px', whiteSpace: 'nowrap'
                }}
            >
                {props.name}
            </Typography>
            {props.name !== "Home Owners" ?
                (
                    <div style={{ marginLeft: '62%', height: '9vh', width: '25%', marginRight:'-5%' }}><SelectAll options={props.options} /></div>
                )
                : (
                    <div style={{ marginLeft: '68%', height: '9vh', width: '21%', marginRight:'5%' }}><Select
                        placeholder={<div style={{ display: 'flex' }}><FilterListOutlinedIcon style={{ color: '#0D5C75' }} /> &nbsp; <div style={{ color: '#888888', fontSize: '15px', marginTop: '3px' }}>Sort users by </div></div>}
                        options={jobStatus}
                        theme={customTheme}
                        styles={customStyles}
                        isSearchable={false}
                        value={status}
                        name="status"
                        onChange={(val) =>
                            setStatus(val)
                        }
                    /></div>
                )
            }
            {/* <div style={{ marginLeft: '70%', height: '9vh', width: '20%' }}><SelectAll options={props.options} /></div> */}
        </Grid>

    )
}

export default SubHeader;
